import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import { ContextGloball } from '../Context/ContextGlobal';
import { Row, Col, Form, Button, ButtonGroup } from 'react-bootstrap';
const server = process.env.REACT_APP_SERVER;

function ReporteProveedores() {
    const { setLoading } = useContext(ContextGloball);
    const [ventana, setVentana] = useState(0);
    const [regional, setRegional] = useState('');
    const [proveedor, setProveedor] = useState("");
    const [proveedores, setProveedores] = useState([]);
    const [numeroSemana, setNumeroSemana] = useState(0);
    const [fechaInicial, setFechaInicial] = useState("");
    const [fechaFinal, setFechaFinal] = useState("");
    const [productos, setProductos] = useState([]);

    const getProveedores = async (fechaInicialAux, fechaFinalAux) => {
        var info = JSON.parse(localStorage.getItem('__react_session__'))
        setRegional(info.regional);
        setLoading(true);

        try {
            var response = await fetch(`${server}/reporte/getProveedores`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': info.regional
                })
            });
            if (response.ok) {
                setLoading(false);
                let data = await response.json();
                console.log(data.ok)
                setProveedores(data.ok);
                setProveedor(data.ok[0].ID_PROVEEDOR)
                getProductosDeProveedor(data.ok[0].ID_PROVEEDOR, fechaInicialAux, fechaFinalAux)
            } else {
                setLoading(false);
                console.log("No se pudo obtener la ruta")
                MsgUtils.msgError("No se pudo obtener los datos de los colaboradores");
            }
        } catch (networkError) {
            MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
        }
    }

    async function getProductosDeProveedor(idProveedor, fechaInicialAux, fechaFinalAux) {
        let dividirProveedor = false;

        if(idProveedor == 147 || idProveedor == 123 || idProveedor == 108){
            dividirProveedor = true;
        }

        let dividirProveedorAux = false;
        if (idProveedor > 10000) {
            dividirProveedorAux = true;
            idProveedor = idProveedor / 100;
        }
        let info = JSON.parse(localStorage.getItem('__react_session__'))
        setLoading(true);
        try {
            var response = await fetch(`${server}/reporte/getProductosDeProveedores`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': info.regional,
                    'id_proveedor': idProveedor,
                    'fecha_inicial': fechaInicialAux,
                    'fecha_final': fechaFinalAux,
                })
            });
            if (response.ok) {
                let data = await response.json();
                console.log(data.ok)

                const proveedoresParaDividir = {
                    147: { id: 147, productos: [165], nombre: "Sofia" },
                    123: { id: 123, productos: [97, 516], nombre: "Industrias Venado" },
                    108: { id: 108, productos: [47, 48, 136], nombre: "Embol" }
                }

                let idsPermitidos = proveedoresParaDividir[idProveedor]?.productos;

                if (dividirProveedorAux) {
                    data.ok = data.ok.filter(p =>
                        idsPermitidos.includes(p.ID_PRODUCTO)
                    );
                }

                if(dividirProveedor){
                    data.ok = data.ok.filter(p =>
                        !idsPermitidos.includes(p.ID_PRODUCTO)
                    );
                }

                setProductos(data.ok);
                setLoading(false);
            } else {
                setLoading(false);
                console.log("No se pudo obtener la ruta")
                MsgUtils.msgError("No se pudo obtener los datos de los colaboradores");
            }
        } catch (networkError) {
            MsgUtils.msgError("No se pudo conectar con la base de datos: " + networkError.message);
        }
    }

    function calcularFecha(semana) {
        setLoading(true);
        let dias = getFormattedDatesOfWeek(2025, semana)
        setFechaInicial(dias[0]);
        setFechaFinal(dias[dias.length - 1]);
        getProductosDeProveedor(proveedor, dias[0], dias[dias.length - 1]);
    }

    function getFormattedDatesOfWeek(year, weekNumber) {
        const jan4 = new Date(year, 0, 4);
        const jan4Day = jan4.getDay() || 7;
        const weekStart = new Date(jan4);
        weekStart.setDate(jan4.getDate() - (jan4Day - 1) + (weekNumber - 1) * 7);

        const formattedDates = [];
        for (let i = 0; i < 7; i++) {
            const currentDate = new Date(weekStart);
            currentDate.setDate(weekStart.getDate() + i);

            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear();

            formattedDates.push(`${day}/${month}/${year}`);
        }

        return formattedDates;
    }

    function getNumeroSemanaHoy(date = new Date()) {
        const tempDate = new Date(date.getTime());
        tempDate.setHours(0, 0, 0, 0);
        tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));

        const firstThursday = new Date(tempDate.getFullYear(), 0, 4);
        const weekNumber = 1 + Math.round(
            ((tempDate - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7
        );
        return weekNumber;
    }

    useEffect(() => {
        let semana = getNumeroSemanaHoy();
        let diasSemanaActual = getFormattedDatesOfWeek(2025, semana)
        setNumeroSemana(semana);
        setFechaInicial(diasSemanaActual[0]);
        setFechaFinal(diasSemanaActual[diasSemanaActual.length - 1]);
        getProveedores(diasSemanaActual[0], diasSemanaActual[diasSemanaActual.length - 1]);
    }, [])

    return (
        <>
            {ventana === 0 && <>
                <div className='container-fluid bg-dark py-2' >
                    <Row>
                        <Col xs={12} sm={6} md={3}>
                            <Form.Group>
                                <Form.Label className="text-white m-0">Seleccione un proveedor</Form.Label>
                                <Form.Select
                                    value={proveedor}
                                    onChange={(e) => { setProveedor(e.target.value); getProductosDeProveedor(e.target.value, fechaInicial, fechaFinal); }}
                                >
                                    {proveedores.map((proveedor, index) => {
                                        return (
                                            <option key={proveedor.ID_PROVEEDOR} value={proveedor.ID_PROVEEDOR}>{proveedor.NOMBRE}</option>
                                        )
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={6} sm={3} md={1} className='mt-1'>

                            <div className='text-white text-center' style={{ fontSize: '15px' }}>
                                # Semana
                            </div>

                            <div className="d-flex justify-content-center">
                                <ButtonGroup size="sm">
                                    <Button variant='light' onClick={() => {
                                        setNumeroSemana(numeroSemana - 1);
                                        calcularFecha(numeroSemana - 1);
                                    }}>
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </Button>
                                    <div className='bg-light fw-bold text-dark my-auto bg-gradient px-1' style={{ fontSize: '25px' }}>
                                        {numeroSemana}
                                    </div>
                                    <Button variant='light' onClick={() => {
                                        setNumeroSemana(numeroSemana + 1);
                                        calcularFecha(numeroSemana + 1);
                                    }}>
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Col>

                        <Col xs={6} sm={3} md={2} className="mt-1">

                            <div className='text-white' style={{ fontSize: '15px' }}>
                                Días
                            </div>

                            <div className="d-flex py-2">
                                <div className='bg-light fw-bold text-dark my-auto bg-gradient px-1' style={{ fontSize: '14px' }}>
                                    {fechaInicial} - {fechaFinal}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className='table-responsive'>
                    <table className="table table-dark table-striped table-hover">
                        <thead className='fw-bold'>
                            <tr>
                                <th style={{ width: '120px' }}>Producto</th>
                                <th style={{ width: '40px' }}>Unidad</th>
                                <th className = 'text-center' style={{ width: '40px' }}>Precio unitario</th>
                                <th className = 'text-center' style={{ width: '80px' }}>Ingresos a Almacen</th>
                                <th className = 'text-center' style={{ width: '80px' }}>Ingresos a Planta</th>
                                <th className = 'text-center' style={{ width: '80px' }}>Ingresos a Sucursales</th>
                                <th className = 'text-center' style={{ width: '80px' }}>Traspasos desde Planta</th>
                                <th className = 'text-center' style={{ width: '80px' }}>Bajas desde Sucursales</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">No se encontraron productos para este proveedor</td>
                                </tr>
                            ) : (
                                productos.map((producto, index) => (
                                    <tr key={index}>
                                        <td className='my-auto'>{producto.DESCRIPCION}</td>
                                        <td className='my-auto'>{producto.DESCRIPCION_UNIDAD}</td>
                                        <td className='text-center my-auto'>{producto.PRECIO_UNITARIO[0]?.PRECIO.toFixed(2) ?? '-'}</td>
                                        <td className='text-center my-auto'>{producto.DETALLE_INGRESOS_ALMACEN[0]?.CANTIDAD ?? '0'}</td>
                                        <td className='text-center my-auto'>{producto.DETALLE_INGRESOS_PLANTA[0]?.CANTIDAD ?? '0'}</td>
                                        <td className='text-center my-auto'>{producto.DETALLE[0]?.CANTIDAD ?? '0'}</td>
                                        <td className='text-center my-auto'>{producto.DETALLE_TRASPASOS_PLANTA[0]?.CANTIDAD ?? '0'}</td>
                                        <td className='text-center my-auto'>{producto.DETALLE_BAJAS_SUCURSALES[0]?.CANTIDAD ?? '0'}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </>}
        </>
    )
}

export default ReporteProveedores